<template>
  <div id="largescreen">
    <div class="bg_main">
      <el-row :gutter="10">
        <el-col :lg="24" :md="24" :sm="24" :xs="24">
          <top-header title="品智企业驾驶舱" />
        </el-col>
      </el-row>
      <el-row :gutter="20" class="padding-tlr" :key="new Date().getTime()">
        <el-col :lg="7" :md="7" :sm="24" :xs="24">
          <component
            :is="left.code"
            v-for="(left, lindex) in comLeft"
            :key="lindex"
            class="card_item_bg"
          ></component>
          <!-- <left-1 class="card_item_bg" />
          <left-2 class="card_item_bg" />
          <left-3 class="card_item_bg" />
          <right-6 class="card_item_bg" />
          <right-10 class="card_item_bg" />
          <right-2 class="card_item_bg" />
          <right-3 class="card_item_bg" />
          <left-5 class="card_item_bg" />
          <left-4 class="card_item_bg" /> -->

          <!-- 隐藏的板块 -->
          <!-- <left-6 class="card_item_bg" />
          <left-7 class="card_item_bg" />
          <left-8 class="card_item_bg" />
          <left-9 class="card_item_bg" />
          <left-10 class="card_item_bg" /> -->
        </el-col>
        <el-col :lg="10" :md="10" :sm="24" :xs="24">
          <component
            :is="center.code"
            v-for="(center, cindex) in comCenter"
            :key="cindex"
            class="card_item_bg"
          ></component>

          <!-- <center-1 class="card_item_bg" />
          <center-3 class="card_item_bg" />
          <center-2 class="card_item_bg" />
          <center-10 class="card_item_bg" />
          <center-9 class="card_item_bg" /> -->

          <!-- <center-8 class="card_item_bg" /> --><!-- 隐藏的板块 -->

          <!-- <center-6 class="card_item_bg" />
          <center-7 class="card_item_bg" />
          <center-12 class="card_item_bg" />
          <center-4 class="card_item_bg" />
          <center-11 class="card_item_bg" />
          <center-14 class="card_item_bg" />
          <center-15 class="card_item_bg" /> -->
        </el-col>
        <el-col :lg="7" :md="7" :sm="24" :xs="24">
          <component
            :is="right.code"
            v-for="(right, rindex) in comRight"
            :key="rindex"
            class="card_item_bg"
          ></component>
          <!-- <right-4 class="card_item_bg" />
          <right-5 class="card_item_bg" />
          <right-7 class="card_item_bg" /> -->

          <!-- <right-8 class="card_item_bg" /> --><!-- 隐藏的板块 -->

          <!-- <right-9 class="card_item_bg" />
          <right-12 class="card_item_bg" />
          <right-1 class="card_item_bg" />
          <left-11 class="card_item_bg" />
          <center-5 class="card_item_bg" />
          <center-13 class="card_item_bg" />
          <center-16 class="card_item_bg" /> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TopHeader from "../components/topHeader";
import Left1 from "./components/left/left_1";
import Left2 from "./components/left/left_2";
import Left3 from "./components/left/left_3";
import Left4 from "./components/left/left_4";
import Left5 from "./components/left/left_5";
import Left12 from "./components/left/left_12";
// import Left6 from "./components/left/left_6";
// import Left7 from "./components/left/left_7";
// import Left8 from "./components/left/left_8";
// import Left9 from "./components/left/left_9";
// import Left10 from "./components/left/left_10";
import Left11 from "./components/left/left_11";
import Center1 from "./components/center/center_1";
import Center2 from "./components/center/center_2";
import Center3 from "./components/center/center_3";
import Center4 from "./components/center/center_4";
import Center5 from "./components/center/center_5";
import Center6 from "./components/center/center_6";
import Center7 from "./components/center/center_7";
// import Center8 from "./components/center/center_8";
import Center9 from "./components/center/center_9";
import Center10 from "./components/center/center_10";
import Center11 from "./components/center/center_11";
import Center12 from "./components/center/center_12";
import Center13 from "./components/center/center_13";
import Center14 from "./components/center/center_14";
import Center15 from "./components/center/center_15";
import Center16 from "./components/center/center_16";
import Right1 from "./components/right/right_1";
import Right2 from "./components/right/right_2";
import Right3 from "./components/right/right_3";
import Right4 from "./components/right/right_4";
import Right5 from "./components/right/right_5";
import Right6 from "./components/right/right_6";
import Right7 from "./components/right/right_7";
// import Right8 from "./components/right/right_8";
import Right9 from "./components/right/right_9";
import Right10 from "./components/right/right_10";
// import Right11 from "./components/right/right_11";
import Right12 from "./components/right/right_12";
export default {
  name: "index",
  components: {
    TopHeader,
    Left1,
    Left2,
    Left3,
    Left4,
    Left5,
    Left12,
    // Left6,
    // Left7,
    // Left8,
    // Left9,
    // Left10,
    Left11,
    Center1,
    Center2,
    Center3,
    Center4,
    Center5,
    Center6,
    Center7,
    // Center8,
    Center9,
    Center10,
    Center11,
    Center12,
    Center13,
    Center14,
    Center15,
    Center16,
    Right1,
    Right2,
    Right3,
    Right4,
    Right5,
    Right6,
    Right7,
    // Right8,
    Right9,
    Right10,
    // Right11,
    Right12,
  },
  data() {
    return {
      comLeft: [],
      comCenter: [],
      comRight: [],
      menuArr: [],
    };
  },
  created() {},
  mounted() {
    const that = this;
    window.addEventListener("message", function (event) {
      console.log(event);
      const frameData = event.data;
      if (frameData.type == "jscViewer") {
        that.$nextTick(() => {
          const comLeftArr = frameData.menuArr.filter((m) => m.place == "left");
          const comCenterArr = frameData.menuArr.filter(
            (m) => m.place == "center"
          );
          const comRightArr = frameData.menuArr.filter(
            (m) => m.place == "right"
          );
          that.comLeft = comLeftArr.sort(function (a, b) {
            return a.component - b.component;
          });
          that.comCenter = comCenterArr.sort(function (a, b) {
            return a.component - b.component;
          });
          that.comRight = comRightArr.sort(function (a, b) {
            return a.component - b.component;
          });
        });
      }
    });
  },
};
</script>

<style scoped lang="scss">
::v-deep#largescreen {
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  padding: 0;
  // background-image: url("../../assets/images/largescreen/home-bg1.jpg");
  overflow-y: auto;
  overflow-x: hidden;
  background: #111111;

  // .bg_main {
  //   background: #111111;
  //   height: 100%;
  // }
  .el-col {
    height: 100%;
    position: relative;
  }
  .padding-tlr {
    padding: 10px 10px 0;
  }
  .padding-lr {
    padding: 0 10px 0;
  }
  .card_item_bg {
    // background: rgba(12, 60, 108, 0.2);
    background: rgba(28, 124, 232, 0.05);
    margin-bottom: 18px;
  }
}
</style>
